import React, { Component } from "react";
import { Col, Alert } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import "./loginStyle.css";

class LoginNotification extends Component {
	render() {
		if (!this.props.loginAnnouncement)
			return null;
		return (
			<div style={{ marginTop: 25 }}>
				<Col mdOffset={1} md={10} lgOffset={3} lg={6}>
					<Alert style={{ backgroundImage: "none", paddingLeft: 35 }}>
						<div
							style={{
								display: "inline-block",
								verticalAlign: "top"
							}}
						>
							<FontAwesome name="info-circle" size="lg" />
						</div>
						<div
							style={{
								color:"#333",
								display: "inline-block",
								paddingLeft: 10,
								width: "95%"
							}}
							dangerouslySetInnerHTML={{
								__html: this.props.loginAnnouncement
							}}
						/>
					</Alert>
				</Col>
			</div>
		);
	}
}

export default LoginNotification;



// WEBPACK FOOTER //
// ./src/components/views/login/LoginNotification.js